<template>
    <div class="w-100 h-100">
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">AE/SAE Community</h2>
            <p class="tw-italic tw-text-gray-700">
                AE/SAE Community viewer.
            </p>
        </b-container>

        <hr />

        <b-container fluid class="tw-my-5">
            <b-row>
                <b-col></b-col>
                <b-col cols="auto">
                    <!-- <label for="start_date">Start Date</label> -->
                    <b-form-datepicker
                        id="start_date"
                        v-model="form.start_date"
                        placeholder="Start Date"
                        class="mb-2"
                        size="lg"
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col cols="auto" v-if="form.start_date">
                    <!-- <label for="end_date">End Date</label> -->
                    <b-form-datepicker
                        id="end_date"
                        :min="form.start_date"
                        v-model="form.end_date"
                        placeholder="End Date"
                        class="mb-2"
                        size="lg"
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col cols="auto">
                    <b-button
                        @click="find()"
                        variant="success"
                        class="px-5"
                        size="lg"
                    >
                        Filter
                    </b-button>
                </b-col>
                <b-col cols="auto">
                    <b-button
                        variant="secondary"
                        class="px-5"
                        size="lg"
                        @click="download()"
                    >
                        Download
                    </b-button>
                </b-col>
                <b-col cols="auto">
                    <b-button
                        variant="info"
                        class="px-5"
                        size="lg"
                        :to="{name: 'ae-sae-community-upload'}"
                    >
                        Upload
                    </b-button>
                </b-col>
            </b-row>
        </b-container>

        <hr />

        <b-table
            striped
            borderless
        selectable
        select-mode="single"
            @row-selected="onRowSelected"
            :fields="fields"
            :items="items"
            class="table-sm tw-text-sm"
        ></b-table>

        <b-modal id="modal-1" size="lg" scrollable title="Details">
            <b-table responsive stacked :items="modal_items"></b-table>
        </b-modal>
    </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from "lodash";

export default {
    mixins: [DashboardBaseTemplate],
    data() {
        return {
            fields: [
                "record_number",
                "kmhfl_code_and_name",
                "date_of_visit",
                "submitted_by",
                "verifiers",
            ],
            items: [],
            form: {},
            modal_items: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        this.find();
    },
    methods: {
        find() {
            const that = this;
            HTTP.get(`/kenya/ae-sae-community`, {
                params: {
                    ...that.form,
                },
            })
                .then((response) => {
                    that.items = response.data;
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        },
        download() {
            const that = this;

            HTTP.get(`/kenya/ae-sae-community`, {
                responseType: "arraybuffer",
                params: {
                    ...that.form,
                    download: 1,
                },
            })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", "ae_sae_community.csv");
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
        },
        onRowSelected(items) {
            let that = this;
            that.modal_items = items;
            this.$bvModal.show("modal-1");
        },
    },
};
</script>
